import {
  Children,
  ReactChild,
  ReactFragment,
  ReactPortal,
  useEffect,
  useState,
} from "react";
import AnimatedPanel from "./AnimatedPanel";

type ChildType = ReactChild | ReactFragment | ReactPortal;

const AnimatedPanels: React.FC<{
  children: React.ReactNode;
  index: number;
}> = ({ children, index }) => {
  const [lastIndex, setLastIndex] = useState(index);
  const [rightChild, setRightChild] = useState<ChildType | null>(null);
  const [leftChild, setLeftChild] = useState<ChildType | null>(null);
  const [panelKey, setPanelKey] = useState(0);
  const childrenArray = Children.toArray(children);
  const resetPanels = () => {
    setRightChild(null);
    setLeftChild(null);
    setLastIndex(index);
    setPanelKey(panelKey + 2);
  };

  useEffect(() => {
    if (index > lastIndex) {
      setRightChild(childrenArray[index]);
      setTimeout(resetPanels, 150);
    }
    if (index < lastIndex) {
      setLeftChild(childrenArray[index]);
      setTimeout(resetPanels, 150);
    }
  }, [index]);

  return (
    <AnimatedPanel right={!leftChild} key={panelKey}>
      <div>{leftChild}</div>
      <AnimatedPanel right={!!rightChild} key={panelKey + 1}>
        <div>{childrenArray[lastIndex]}</div>
        <div>{rightChild}</div>
      </AnimatedPanel>
    </AnimatedPanel>
  );
};

export default AnimatedPanels;
